import type { TourMedia } from './tour-video-slot';

// The tour build supplies the environment's Bunny delivery origin. Keep the
// page-guide assets in their own versioned prefix so approved media stays intact.
const CDN_ORIGIN = new URL(
  import.meta.env?.VITE_TOUR_MEDIA_BASE_URL ||
  'https://adsmanager-staging.b-cdn.net/onboarding/refreshed-20260930-v1',
).origin;
const DIALS_BASE = `${CDN_ORIGIN}/onboarding/inspiration-20260930-v2`;
const BASE = `${CDN_ORIGIN}/onboarding/inspiration-20260930-v3`;

export const PAGE_GUIDE_MEDIA: Record<string, TourMedia> = {
  'dials-add-angles': {
    src: `${DIALS_BASE}/dials-add-angles.mp4`,
    poster: `${DIALS_BASE}/dials-add-angles.jpg`,
    label: 'Choose image settings and Add angles',
  },
  'inspiration-overview': { src: `${BASE}/inspiration-overview.mp4`, poster: `${BASE}/inspiration-overview.jpg`, label: 'Explore the Inspiration image library' },
  'inspiration-search': { src: `${BASE}/inspiration-search.mp4`, poster: `${BASE}/inspiration-search.jpg`, label: 'Search Inspiration images with a keyword' },
  'inspiration-filters': { src: `${BASE}/inspiration-filters.mp4`, poster: `${BASE}/inspiration-filters.jpg`, label: 'Refine Inspiration images with niche, format, and style filters' },
  'inspiration-collection': { src: `${BASE}/inspiration-collection.mp4`, poster: `${BASE}/inspiration-collection.jpg`, label: 'Choose Images and open a saved brand collection' },
  'inspiration-clone': { src: `${BASE}/inspiration-clone.mp4`, poster: `${BASE}/inspiration-clone.jpg`, label: 'Inspect an image ad and open its Clone destination picker' },
  'inspiration-reset': { src: `${BASE}/inspiration-reset.mp4`, poster: `${BASE}/inspiration-reset.jpg`, label: 'Remove an individual filter and reset Inspiration search' },
};
